import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert, Form, Input, Button } from 'antd'
import * as req from '../../common/requests'

import css from '../../common/Form.css'

function delay(t) {
  return new Promise(((resolve) => {
    setTimeout(resolve, t)
  }))
}

export default class TopsSync extends Component {
  static propTypes = {
    practiceId: PropTypes.string.isRequired,
    onError: PropTypes.func.isRequired,
    getAndSaveLocationList: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    setStepStatus: PropTypes.func.isRequired,
    step: PropTypes.number.isRequired,
  }

  state = {
    remoteDbId: null,
    ip: null,
    username: null,
    password: null,
    port: 5432,
    loading: true,
    showForm: false,
    pingSuccess: false,
  }

  componentWillMount() {
    const { practiceId, onError, setStepStatus } = this.props
    req.getRemoteDatabases(practiceId)
      .then((res) => {
        if (res.length > 0) {
          const db = res[0]
          this.setState({
            remoteDbId: db.id,
            ip: db.address,
            port: db.database_port,
            username: db.username,
          })
          return req.checkDbCredentials(db.id)
        }
        return Promise.resolve(false)
      })
      .then((res) => {
        this.setState({
          pingSuccess: !!res,
          loading: false,
        })
        // reset step status to default
        setStepStatus(this.props.step, '')
      })
      .catch((err) => {
        this.setState({ loading: false })
        setStepStatus(this.props.step, 'error')
        if (err.message !== 'Not Found') {
          onError(err)
        }
      })
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleConnect = (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    this.props.clearError()

    let remoteDbId
    const requestPromise = this.createOrUpdateRemoteDb()
    requestPromise
      .then((res) => {
        remoteDbId = res.id
        this.setState({
          remoteDbId,
        })
        return req.checkDbCredentials(remoteDbId)
      })
      .then(() => (
        req.scheduleSync(remoteDbId)
      ))
      .then(() => (
        delay(600).then(() => this.pollLocations(0))
      ))
      .then(() => {
        this.setState({
          loading: false,
          pingSuccess: true,
        })
        this.props.setStepStatus(this.props.step, '')
      })
      .catch((err) => {
        this.setState({
          loading: false,
          pingSuccess: false,
        })
        this.props.setStepStatus(this.props.step, 'error')
        this.props.onError(err)
      })
  }

  createOrUpdateRemoteDb = () => {
    const { remoteDbId, ip, password, port, username } = this.state
    const { practiceId } = this.props
    const dbParams = {
      address: ip,
      database_password: password,
      database_port: port,
      practice_id: practiceId,
      username,
    }
    return this.state.remoteDbId ?
      req.updateRemoteDatabase(practiceId, remoteDbId, dbParams) :
      req.createRemoteDatabase(practiceId, dbParams)
  }

  pollLocations = (count) => {
    const { practiceId, getAndSaveLocationList } = this.props
    return getAndSaveLocationList(practiceId)
      .then((res) => {
        if (res.length > 0) {
          this.setState({ loading: false })
          return Promise.resolve(res)
        } else if (count < 20) {
          return delay(600).then(() => this.pollLocations(count + 1))
        }
        this.setState({ loading: false })
        return Promise.reject(new Error('Connection timed out. Please try again in a few minutes.'))
      })
  }

  showForm = () => {
    this.setState({
      showForm: true,
    })
  }

  render() {
    const {
      ip, username, password, loading, port, showForm, pingSuccess,
    } = this.state
    return (
      <div>
        {pingSuccess && !showForm ? (
          <div>
            <Alert
              type="success"
              message="Success"
              description="Database connection successful"
            />
            <Button onClick={this.showForm}>Update Database Credentials</Button>
          </div>
        ) : (
          <Form onSubmit={this.handleConnect}>
            <h3>topsOrtho Sync</h3>
            <Form.Item label="IP address" className={css.input}>
              <Input
                placeholder="e.g. 000.000.000.000"
                value={ip}
                onChange={this.handleInputChange}
                name="ip"
              />
            </Form.Item>
            <Form.Item label="Username" className={css.input}>
              <Input
                placeholder="e.g. osmuser"
                value={username}
                onChange={this.handleInputChange}
                name="username"
              />
            </Form.Item>
            <Form.Item label="Password" className={css.input}>
              <Input
                placeholder=""
                value={password}
                onChange={this.handleInputChange}
                name="password"
                type="password"
              />
            </Form.Item>
            <Form.Item label="Port">
              <Input
                placeholder="e.g. 5432"
                value={port}
                onChange={this.handleInputChange}
                name="port"
                className={css.input}
              />
            </Form.Item>

            <Form.Item>
              <Button
                htmlType="submit"
                loading={loading}
                disabled={!ip || !password || !port}
              >
                Connect
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/TopsSync.js